import { useContext, useState, useEffect } from 'react';
import Message from '../../components/message/message';
import Layout from '../../components/UI/layout/layout';
import AuthContext from '../../stores/authContext';
import axios from 'axios';
import { NavLink } from 'react-router-dom';
import Table from '../../components/UI/table/table';
import Pager from '../../components/pager/pager';

function OrdersIndex() {
    const { message, setMessage, user } = useContext(AuthContext)
    const [orders, setOrders] = useState('')
    const [count, setCount] = useState(0)
    const [filter, setFilter] = useState('')
    const [firstItem, setFirstItem] = useState(0)
    const [itemsToShow] = useState(20)

    useEffect(() => {
        if (user && user.token) {
            axios.get(`${process.env.REACT_APP_API_PATH}/api/orders/${firstItem}/${itemsToShow}/${filter && filter.length > 0 ? filter : 0}`, {
                headers: {
                    'auth-token': user.token
                }
            }).then(res => {
                setOrders(res.data)
            })
    
            axios.get(`${process.env.REACT_APP_API_PATH}/api/orders/count/${filter && filter.length > 0 ? filter : 0}`, {
                headers: {
                    'auth-token': user.token
                }
            }).then(res => {
                setCount(res.data[0].item_count)
            })
        }
    }, [user, filter, firstItem, itemsToShow])

    useEffect(() => {
        setFirstItem(0)
    }, [filter])

    return (
        <Layout>
            { message &&
                <Message 
                    classes = { message.class }
                    message = { message.message }
                    closeMessage = { () => setMessage(null) }
                />
            }
            <h1>Tilaukset</h1>
            <input style={{ float: 'right', padding: '10px' }} value={ filter } placeholder='Hae...' onChange={ (e) => setFilter(e.target.value) } />
            { orders &&
                <Table>
                    <thead>
                        <tr>
                            <th>Tilausnumero</th>
                            <th>Osoite</th>
                            <th>Tilannut</th>
                            <th>Hinta</th>
                            <th>Tila</th>
                            <th>Lisätty</th>
                            <th>Toiminnot</th>
                        </tr>
                    </thead>
                    <tbody>
                        { orders.map(order => {
                            return (
                                <tr key={ order.id }>
                                    <td>{ order.order_number }</td>
                                    <td>{ order.address }</td>
                                    <td>{ order.name }</td>
                                    <td>{ order.price + ' €' }</td>
                                    <td>{ order.order_status }</td>
                                    <td>{ `${new Date(order.created_at).getDate()}.${new Date(order.created_at).getMonth() + 1}.${new Date(order.created_at).getFullYear()}` }</td>
                                    <td>
                                        <NavLink to={`/tilaukset/${order.id}`}>Näytä</NavLink>
                                    </td>
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
            }
            <Pager 
                firstItem = { firstItem }
                itemsToShow = { itemsToShow }
                count = { count }
                filter = { filter }
                handleSetFirstItem = { (value) => setFirstItem(value) }
            />
        </Layout>
    )
}

export default OrdersIndex